import React from "react"

import { Grid} from "@mui/material"

import { CustomersService } from "services/customers.service"
import {
	ErrorResponse,
	RestResponse
} from "@sinossi/mates-react-library";

import CustomerCard from "../customer-card/customer-card";
import {
	CustomersListProps,
	CustomersListState
} from "./models";
import { Customer } from "../../../pages/models";

export default class CustomersList extends React.Component<CustomersListProps, CustomersListState>
{
	/**
	 * Sends the terminate request for a customer and keeps the customer id available for the response handler.
	 */
	private deleteCustomer = (customerId: string) => {
		CustomersService.deleteCustomer(customerId, (response: RestResponse<Customer, ErrorResponse>) => {
			this.customerDeleteCallback(customerId, response);
		});
	};

	/**
	 * Removes a successfully terminated customer from the visible list before refreshing the backend data.
	 */
	private customerDeleteCallback = (customerId: string, response: RestResponse<Customer, ErrorResponse>) => {
		if(!response.hasError()) {
			this.props.removeCustomerFromList(customerId);
		}

		this.props.refreshList(false);
	};

	/**
	 * Sends the recover request for a customer and refreshes the list when it completes.
	 */
	private recoverCustomer = (customerId: string) => {
		CustomersService.recoverCustomer(customerId, this.customerRecoverCallback);
	};

	/**
	 * Refreshes the visible customer list after a recover request completes.
	 */
	private customerRecoverCallback = () => {
		this.props.refreshList();
	};

	render()
	{
		return (<>
			<Grid container alignItems="stretch" spacing={3} marginTop={3}>
				{this.props.list?.map(
					(item, index) => ( <Grid item container key={item.id} lg={4} sm={6} xs={12} textAlign={"left"}><CustomerCard
						customer={item}
						emitDeleteCallback={this.deleteCustomer}
						emitRecoverCallback={this.recoverCustomer}
						user={this.props.user}/></Grid>))}
			</Grid>

		</>);
	}
}
